import React from 'react';
import Card from 'react-bootstrap/Card';
import CarsIcon from '../../Assets/vidaslogo.svg'


export function Footer(props) {
  return (
    <Card className='bg-dark text-light'>
      <Card.Body>
        <Card.Header>
          <img src={CarsIcon} width={props.size + 'rem'} alt="Vida Trans" />
          <span className='mx-2'>Vida Trans</span> 
        </Card.Header>
        {/* <Card.Text className="d-flex flex-column">
            <span><strong>Vida</strong></span>
            <span>Cara Pesan</span>
            <span>Pusat Bantuan</span>
            <span>Karier</span>
            <span>Tentang Kami</span>
        </Card.Text> */}
      </Card.Body>
    </Card>
  );
}

